export default "__VITE_ASSET__CmZSnLfh__"